import { Link } from '@tanstack/react-router'

import { InstagramIcon, TiktokIcon } from '@/components/icons/common'

export default function Footer() {
  return (
    <>
      <div className="mt-20 w-full px-6 py-8 md:px-36">
        <div className="flex w-full flex-col justify-between gap-8 md:flex-row md:gap-0">
          <div>
            <img src="/YES-logo.png" className="h-7 md:h-9" />
          </div>
          <div className="md:text-md flex flex-row gap-2 text-sm md:flex-col md:font-semibold">
            <div className="text-[#4E4E4E]">More questions? </div>
            <div>Email us at : halo@yes.co.id</div>
          </div>
          <div className="flex flex-col gap-2">
            <div className="md:font-semibold">
              Licensed, Registered, authorized by:
            </div>
            <div className="mt-2 flex flex-row gap-4 md:mt-0">
              {/* <img src="/img/landing/pse-logo.png" /> */}
              <img src="/img/landing/kominfo.png" className="h-12" />
              <img src="/img/landing/disnaker-text.png" className="h-11" />
            </div>
          </div>
          <div className="flex flex-col gap-4">
            <div className="flex flex-row gap-2 md:flex-col">
              <div className="flex items-center gap-4 md:font-semibold">
                Perusahaan
              </div>
              <div>
                <a href="https://clicky.id/yesnowhiring">
                  <div>Karir</div>
                </a>
              </div>
            </div>
            <div className="flex flex-row gap-2 md:flex-col">
              <div className="flex items-center gap-4 md:font-semibold">
                Temukan kami di:
              </div>
              <div className="flex items-center gap-4">
                <InstagramIcon
                  onClick={() =>
                    window.open(
                      'https://instagram.com/yes.co.id_official',
                      '_blank'
                    )
                  }
                />
                <TiktokIcon
                  onClick={() =>
                    window.open('https://www.tiktok.com/@yes.co.id', '_blank')
                  }
                />
              </div>
            </div>
          </div>
        </div>
        <div className="mt-8 flex justify-center text-center text-sm text-[#4E4E4E]">
          copyright 2025 YES.co.id
          <br />
          All Rights Reserved
        </div>
      </div>
    </>
  )
}
